export default "__VITE_ASSET__c30_wyxY__"